import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, reset, formValueSelector } from "redux-form";
import Button from "react-bootstrap-button-loader";
import { withRouter } from "react-router-dom";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { COMMON_FAIL_MESSAGE } from "Constants";
import {
  addeditUsersCategory,
  validateUserCategoryName,
  addUserCategory,
  updateUserCategory,
} from "DashboardUserAction";
import { showError, showSuccess } from "ReduxErrorBar";
import LocaleStrings from "Languages";

class AddCategory extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = { loading: false };
  }

  onFormSubmit = (values) => {
    values["groupname"] = values.groupname.trim();

    this.setState({ loading: true });
    if (this.props.edit) {
      var dicValues = { ...values };
      this.props.validateUserCategoryName(
        this.props.session,
        dicValues,
        (response) => {
          if (response.success === 1) {
            this.props.updateUserCategory(
              this.props.session,
              dicValues,
              (response) => {
                if (response.success) {
                  this.props.showSuccess(
                    LocaleStrings.user_manage_user_category_form_success_update
                  );
                  this.props.addeditUsersCategory({
                    toAdd: false,
                    toEdit: false,
                  });
                  this.props.reset();
                } else {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                }
                this.setState({ loading: false });
              }
            );
          } else {
            this.props.showError(
              LocaleStrings.user_manage_user_category_form_error_name_exist
            );
            this.setState({ loading: false });
          }
        }
      );
    } else {
      var dicValues = { ...values, type: "custom" };
      this.props.validateUserCategoryName(
        this.props.session,
        dicValues,
        (response) => {
          if (response.success === 1) {
            this.props.addUserCategory(
              this.props.session,
              dicValues,
              (response) => {
                if (response.success) {
                  this.props.showSuccess(
                    LocaleStrings.user_manage_user_category_form_success_add
                  );
                  this.props.addeditUsersCategory({
                    toAdd: false,
                    toEdit: false,
                  });
                  this.props.reset();
                } else {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                }
                this.setState({ loading: false });
              }
            );
          } else {
            this.props.showError(
              LocaleStrings.user_manage_user_category_form_error_name_exist
            );
            this.setState({ loading: false });
          }
        }
      );
    }
  };

  componentWillUnmount() {
    document.removeEventListener("submit", this.onFormSubmit);
  }

  close = () => {
    this.props.addeditUsersCategory({ toAdd: false, toEdit: false });
  };

  render() {
    var { handleSubmit, pristine, dirty, reset, invalid, submitting, valid } =
      this.props;

    return (
      <div className="basicform" style={{ minHeight: 300 }}>
        <div className="row">
          <div className="col-md-12">
            <form onSubmit={handleSubmit(this.onFormSubmit.bind(this))}>
              <Field
                name="groupname"
                label={
                  LocaleStrings.user_manage_user_category_form_label_category_name
                }
                placeholder={
                  LocaleStrings.user_manage_user_category_form_ph_category_name
                }
                type="text"
                component={this.renderFieldText}
                mandatory="true"
                labelposition={LABEL_POSITION_TOP}
              />
              <div className="buttonsFooter">
                <Button className="btn btn-custom-white" onClick={this.close}>
                  {LocaleStrings.button_close}
                </Button>
                <Button
                  className="btn btn-custom-blue ml-10"
                  loading={this.state.loading}
                  type="submit"
                  disabled={pristine || invalid || submitting}
                >
                  {LocaleStrings.button_save}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};
  var groupname = values["groupname"];

  if (!groupname || groupname.trim() === "") {
    errors["groupname"] = "Required";
  }

  return errors;
}

function mapStateToProps(state) {
  var initValues = state.addEditUserCategory;

  return {
    session: state.session,
    initialValues: initValues,
    edit: state.addEditUserCategory.toEdit,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    addeditUsersCategory,
    validateUserCategoryName,
    addUserCategory,
    updateUserCategory,
    showError,
    showSuccess,
  })(
    reduxForm({
      validate,
      form: "CategoryForm",
      enableReinitialize: true,
      keepDirtyOnReinitialize: true,
    })(AddCategory)
  )
);
